<template>
  <div v-title data-title="广东多对多物联集团股份有限公司">
    <div class="introBox container">
      <!-- <div class="support_1"></div> -->
      <img
        style="width: 100%"
        src="https://img.duoduiduo.com/gg/26/7/c38c29be721a479f804ab255a138526f.jpg"
        alt=""
      />
      <!-- 
      <div class="wrapperxxx">
        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
          <swiper-slide v-for="(item, index) in swiperData" :key="index">
            <img style="width: 100%; display: block" :src="item.imgUrl" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div> -->
    </div>

    <div>
      <img
        style="display: block; width: 100%"
        src="https://img.duoduiduo.com/gg/19/27/9668ba6bb22d46af94fa846426217af8.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOptionTop: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
        },
        loop: true,
        autoplay: {
          delay: 4000, //1秒切换一次
        },
        // direction: "horizontal"
      },
      swiperData: [
        {
          imgUrl: require("../../assets/images/matter/matter_lun1.jpg"),
        },
        {
          imgUrl: require("../../assets/images/matter/matter_lun2.jpg"),
        },
        {
          imgUrl: require("../../assets/images/matter/matter_lun3.jpg"),
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
.introBox {
  // margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/matter/matter.vue